import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AutoresponderValidation } from 'uplisting-frontend/validations';

export default class AutoresponderRepositoryService extends BaseRepositoryService<
  ModelRegistry['autoresponder']
> {
  recordName = 'autoresponder';
  implementMethods = ['buildChangeset', 'findRecord', 'unloadAll'];

  validation = AutoresponderValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/autoresponder': AutoresponderRepositoryService;
  }
}
